module.exports = __webpack_public_path__ + "static/media/kids.dbf8be41.jpg";